<template>
  <div>
    <div class="license_key">
      <!--<img src="../../assets/chat.png" alt="" class="chat">-->
      <div class="license_title">
        <i class="icon-license"></i>
        {{ $t('dashboard.licenseKey') }}
      </div>
      <div class="license_info" :class="{ padding: !extraLicenseKeys }">
        <ul class="license_list">
          <li v-for="app in bindApps" :key="app.key" class="license_item">
            <!-- key -->
            <p>
              {{ $t('dashboard.licenseKey') }} <span>{{ app.key }}</span>
            </p>
            <!-- pid -->
            <p>
              {{ $t('dashboard.packageName') }}
              <span>{{ app.pid ? app.pid : lang === 'en' ? 'Not Bound' : '未绑定' }}</span>
            </p>
            <!-- form -->
            <form :inline="true" :model="formModel" v-if="!app.pid" class="custom_form">
              <div class="custom_input">
                <input v-model="formModel.pid[app.key]" placeholder="Package Name" />
              </div>
              <div class="custom_button">
                <button type="primary" @click="onSubmit(app.key, app.func)" :loading="loading">
                  {{ lang === 'en' ? 'Bind' : '绑定' }}
                </button>
              </div>
            </form>
            <!-- message -->
            <small v-if="!app.pid" class="note">{{ `* ${$t('dashboard.bindMessage2')}` }}</small>
            <small v-else class="note">{{ `* ${$t('dashboard.bindMessage1')}` }}</small>
            <!-- wifi -->
            <div v-if="app.pid && !app.wifi" class="wifi-wrapper">
              <p>{{ $t('dashboard.enableWifi') }}</p>
              <div class="custom_button">
                <button type="primary" @click="enableWifi(app.key, app.pid)" :loading="loading">
                  {{ lang === 'en' ? 'Enable' : '激活' }}
                </button>
              </div>
            </div>
            <div v-else-if="app.pid && app.wifi" class="wifi-wrapper">
              <p>{{ $t('dashboard.wifiSecuritySDK') }}</p>
              <strong>{{ lang === 'en' ? 'Enabled' : '已激活' }}</strong>
            </div>
            <!-- delete button -->
            <div class="delete-wrapper">
              <button 
                type="button" 
                class="delete-button" 
                @click="handleDelete(app.key)" 
                :loading="deletingKey === app.key"
              >
                {{ lang === 'en' ? 'Delete' : '删除' }}
              </button>
            </div>
          </li>
        </ul>
        <img src="../../assets/img/licenseKey.png" alt="" class="mark" />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message, MessageBox } from 'element-ui'

  export default {
    name: 'license',
    props: {
      licenseKey: {
        type: String,
        required: true
      },
      extraLicenseKeys: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        formModel: {
          pid: []
        },
        bindApps: [],
        loading: false,
        deletingKey: null
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      log(item) {
        console.log(item)
      },
      onSubmit: async function(licenseKey, func) {
        try {
          // start loading..
          this.loading = true
          // set data which is needed to bind
          const data = {
            licenseKey: licenseKey,
            func: func,
            pid: this.formModel.pid[licenseKey]
          }
          // bind the package name with the user's license key
          const response = await axios.patch(`/api/product/bind-app`, data)
          // show the successful message
          Message({
            type: 'success',
            message: response.data.message,
            showClose: true
          })
          // stop loading..
          this.loading = false
          // update bindApps to rerender and display the latest info
          // console.log(response.data.data.Attributes, this.bindApps)
          this.bindApps = [
            ...this.bindApps.filter(app => response.data.data.Attributes.key !== app.key),
            response.data.data.Attributes
          ]
          // console.log(this.bindApps, 'this.bindApps')
        } catch (err) {
          // show the error message
          Message({
            type: 'error',
            message: err.response.data.statusCode + ' ' + err.response.data.message,
            showClose: true
          })
          console.error({ err })
          // stop loading..
          this.loading = false
        }
      },
      fetchBindApp: async function() {
        try {
          const response = await axios.get('/api/product/bind-app')
          // Only show active keys (keys that exist in codes API table)
          this.bindApps = response.data.data || []
          // Emit deleted keys to parent component
          this.$root.$emit('deletedLicenseKeys', response.data.deletedKeys || [])
          console.log(this.bindApps, 'this.bindApps')
        } catch (err) {
          console.log({ err })
        }
      },
      enableWifi: async function(licenseKey, pid) {
        try {
          await axios.post('/api/product/add-wifi', { licenseKey, pid })
          // todo: not good approach
          // to show the latest wifi SDK status after enabling wifi
          this.fetchBindApp()
        } catch (err) {
          console.log({ err })
        }
      },
      handleDelete: async function(licenseKey) {
        try {
          // Show confirmation dialog
          const confirmMessage = this.lang === 'en' 
            ? 'Are you sure you want to delete this license key? This action cannot be undone.'
            : '您确定要删除此许可密钥吗？此操作无法撤销。';
          
          const confirmTitle = this.lang === 'en' 
            ? 'Delete License Key'
            : '删除许可密钥';
          
          const confirmButtonText = this.lang === 'en' 
            ? 'Delete'
            : '删除';
          
          const cancelButtonText = this.lang === 'en' 
            ? 'Cancel'
            : '取消';
          
          await MessageBox.confirm(confirmMessage, confirmTitle, {
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            type: 'warning',
            confirmButtonClass: 'el-button--danger'
          });

          // User confirmed, proceed with deletion
          this.deletingKey = licenseKey;
          const response = await axios.delete(`/api/product/license-key/${licenseKey}`);
          
          Message({
            type: 'success',
            message: response.data.message,
            showClose: true
          });

          // Refresh the license keys list
          await this.fetchBindApp();
          
          this.deletingKey = null;
        } catch (err) {
          this.deletingKey = null;
          // User cancelled - do nothing
          if (err === 'cancel') {
            return;
          }
          // Show error message
          const errorMessage = (err.response && err.response.data && err.response.data.message) 
            || (this.lang === 'en' ? 'Failed to delete license key' : '删除许可密钥失败');
          Message({
            type: 'error',
            message: errorMessage,
            showClose: true
          });
          console.error({ err });
        }
      }
    },
    mounted() {
      this.fetchBindApp()
      // update bindApps to rerender and display the latest info after the user generate a new key
      this.$root.$on('updateKeys', async newData => {
        try {
          this.bindApps = newData
        } catch (err) {
          console.log({ err })
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .license_key {
    height: 100%;
    background: $white;
    @include border-radius(6px);
    padding: 25px 23px 14px;
    font-size: 18px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 13px;
    border: $border;
    @include box-shadow;
    .chat {
      width: 38px;
      height: 45px;
      @include absolute-right-bottom(-20px, 15px);
      position: absolute;
      bottom: 15px;
      right: -20px;
    }
    .license_title {
      height: 18px;
      font-family: NexaBold;
      .icon-license {
        font-size: 16px;
      }
    }
    .license_info {
      height: 100%;
      border: $border;
      @include border-radius(6px);
      margin-top: 20px;
      font-size: 14px;
      padding: 10px 20px;
      color: #777;
      position: relative;
      & p {
        display: flex;
        span {
          color: #42434b;
          margin-left: 5px;
        }
      }
      .btn {
        margin-left: 11px;
        border: 1px solid #d1d4d9;
        @include border-radius(3px);
        background: linear-gradient(left, #f5f7f9, #ededf2);
      }
      .mark {
        width: 100px;
        aspect-ratio: 1 / 1;
        border-bottom-right-radius: 4px;
        @include absolute-right-bottom(0, 0);
      }
      .license_list {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .license_item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 80%;
        padding: 8px;
        border-radius: 8px;
        border: 1px solid #d1d4d9;
      }
      .custom_form {
        display: grid;
        grid-template-columns: 1fr max-content;
        gap: 8px;
      }
      .custom_input > input {
        width: 100%;
        padding: 8px 8px;
        border-radius: 4px;
        border: 1px solid #d1d4d9;
      }
      .custom_button > button {
        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid #409eff;
        background-color: #409eff;
        color: white;
      }
      .note {
        font-size: 11px;
        font-style: italic;
        margin-top: -4px;
      }
      .wifi-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #d1d4d9;
        border-radius: 8px;
        padding: 8px 8px;

        & button {
          cursor: pointer;
        }
        & strong {
          color: hsl(156, 50%, 50%);
        }
      }
      .delete-wrapper {
        margin-top: 8px;
        display: flex;
        justify-content: flex-end;
        
        .delete-button {
          padding: 6px 12px;
          border-radius: 4px;
          border: 1px solid #f56c6c;
          background-color: #f56c6c;
          color: white;
          cursor: pointer;
          font-size: 12px;
          transition: opacity 0.2s;
          
          &:hover {
            opacity: 0.8;
          }
          
          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }
        }
      }
    }
    .padding {
      padding: 22px 0 22px 14px;
    }
  }
  @media screen and (max-width: 1089px) {
    .license_key .license_info p span {
      display: inline-block;
      @include text-overflow(60%);
    }
  }
  @media screen and (max-width: 760px) {
    .license_key {
      height: auto;
      box-shadow: none;
      font-size: 14px;
      .padding {
        padding: 22px 14px;
      }
      .license_info {
        height: auto;
        .mark {
          display: none;
        }
        .license_item {
          width: auto;
        }
        & p {
          display: block;
          /* line-height: 30px; */
          margin-top: 10px;
          & span {
            display: block;
            width: 90%;
            overflow: visible;
            white-space: normal;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Dashboard/license.vue